import * as types from "../actions/types";
/*******************
@purpose : Intital home reducer data
@Author : INIC
******************/
const initialState = {
  blogMetaData:[],
  blogList:[],
  totalRecord:'',
};

/*******************
@purpose : Common Reducer
@Parameter : {ini_data, action}
@Author : INIC
******************/
export default function common(ini_data = initialState, action = {}) {
  switch (action.type) {
    // Set Various Custom Redux Key Data /

        case types.SET_BLOG_META_DATA:
          return Object.assign({}, ini_data, {
            blogMetaData: action.data,

          });
          case types.SET_BLOG_LIST:
          return Object.assign({}, ini_data, {
            blogList: [...ini_data.blogList,...action.data],
          });
          case types.SET_BLOG_LIST_CLEAR:
          return Object.assign({}, ini_data, {
            blogList: [],
          });
          case types.SET_BLOG_TOTAL_RECORD:
          return Object.assign({}, ini_data, {
            totalRecord: action.data,
          });

    default:
      return ini_data;
  }
}
